import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  titleSection: {
    color: theme.palette.primary.contrastText,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  emailSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('xl')]: {
      width: '50%'
    }
  },
  inputLabel: {
    fontWeight: 700,
    color: theme.palette.primary.contrastText
  },
  input: {
    borderRadius: theme.spacing(3),
    marginTop: theme.spacing(1),
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(3)
    }
  },
  invalidInput: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    '& .MuiSvgIcon-root': {
      marginRight: theme.spacing(0.5)
    }
  },
  submitButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '45px',
    minWidth: '180px',
    borderRadius: '30px',
    background: theme.palette.primary.contrastText,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(5),
    '&:hover': {
      background: theme.palette.primary.dark
    },
    '& .MuiButton-label': {
      flexWrap: 'nowrap'
    }
  },
  containerSendEmail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  containerSendEmailInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  sendEmailInfoSubtitle: {
    fontWeight: 400,
    textAlign: 'center',
    width: '60%'
  },
  containerSendEmailAgain: {
    display: 'flex',
    marginTop: theme.spacing(2),
    '& :first-child': {
      marginRight: '5px'
    },
    '& .MuiTypography-root': {
      color: theme.palette.grey[300]
    }
  },
  sendAgainButton: {
    padding: 0,
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent !important',
      textDecoration: 'underline'
    },
    '&:active, &:focus': {
      backgroundColor: 'transparent !important'
    }
  }
}))
